import TrashIcon from '@/assets/icons/Monitoring/eva_trash-2-outline.svg?react';
import { Button } from '@/components/atoms/NewPcButton';

const KeywordTable = ({ goods, relatedList, onRemove, maxHeight = 280, isMockGoods }) => {
  // 최신 날짜의 RelatedKeywordsRanking 추출
  const latestRanking =
    goods?.MonitoringGoodsDetailDailyList?.length > 0
      ? goods.MonitoringGoodsDetailDailyList.slice().sort(
          (a, b) => new Date(b.MonitoringDate) - new Date(a.MonitoringDate),
        )[0].RelatedKeywordsRanking
      : [];

  // 키워드별 메타 정보 매핑
  const getKeywordMeta = (keyword) => {
    if (!latestRanking) return { rank: '-', position: '-', searchVolume: '-' };
    const found = latestRanking.find((k) => k.Keyword === keyword);
    return {
      rank: found ? (found.Rank > 0 ? `${found.Rank}위` : '1000위 밖') : '-',
      position: found?.PagePosition || '-',
      searchVolume: '-', // API에 없으므로 일단 "-"
    };
  };

  return (
    <div className="mt-4 overflow-auto rounded-[10px]" style={{ maxHeight }}>
      <table className="h-full w-full min-w-[480px] text-sm">
        <thead className="border-b border-gr-300">
          <tr className="sticky top-0 z-10 bg-gr-50 text-gr-800 Caption1M12">
            <th className="whitespace-nowrap px-[11px] py-[9px] text-left Caption1M12">키워드</th>
            <th className="whitespace-nowrap px-[11px] py-[9px] text-left Caption1M12">
              검색량(월)
            </th>
            <th className="whitespace-nowrap px-[11px] py-[9px] text-left Caption1M12">순위</th>
            <th className="whitespace-nowrap px-[11px] py-[9px] text-left Caption1M12">노출위치</th>
            <th className="whitespace-nowrap px-[11px] py-[9px] text-right Caption1M12">삭제</th>
          </tr>
        </thead>
        <tbody>
          {relatedList.length === 0 ? (
            <tr>
              <td colSpan={5} className="py-4 text-center text-gr-400 Caption1M12">
                추가된 키워드가 없습니다
              </td>
            </tr>
          ) : (
            relatedList.map((keyword) => {
              const meta = goods
                ? getKeywordMeta(keyword)
                : { rank: '-', position: '-', searchVolume: '-' };
              return (
                <tr key={keyword} className="h-[48px] border-b last:border-b-0">
                  <td className="px-2 py-2 text-gr-800 Body5M14">{keyword}</td>
                  <td className="px-2 py-2 text-left text-gr-800 Body5M14">{meta.searchVolume}</td>
                  <td className="px-2 py-2 text-left text-gr-800 Body5M14">{meta.rank}</td>
                  <td className="px-2 py-2 text-left text-gr-800 Body5M14">{meta.position}</td>
                  <td className="px-2 py-2 text-right text-gr-800 Body5M14">
                    <Button
                      variant="line"
                      size={'icon'}
                      onClick={() => onRemove(keyword)}
                      className="rounded-[8px] border p-[7px] text-gr-400 hover:text-point-500"
                      aria-label="삭제"
                    >
                      <TrashIcon />
                    </Button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default KeywordTable;
